import styled, { keyframes, css } from "styled-components";
import media from "constants/media";

export const rotate = keyframes`
    from {
        transform: rotate(0deg);
    }

    to {
        transform: rotate(360deg);
    }
`;

export const pulsate = keyframes`
    0% {
        opacity: 1;
    }

    70% {
        opacity: 0.5;
    }

    100% {
        opacity: 1;
    }
`;

export const Location = styled.div`
    display: flex;
    align-items: center;

    color: var(--color-peach);

    cursor: pointer;

    > svg {
        width: 15px;
        height: 15px;

        margin-right: 5px;
    }

    ${({ isLoading }) =>
        isLoading &&
        css`
            > svg {
                animation: ${rotate} 2s cubic-bezier(0.4, 0, 0.2, 1) infinite;
                fill: #39c2ee;
            }

            animation: ${pulsate} 1s cubic-bezier(0.4, 0, 0.2, 1) infinite;
        `}
`;

export const LocationText = styled.span`
    display: none;

    ${media.mdUp`
        display: inline;
    `}
`;
